import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Button } from 'react-bootstrap5';

import Modal from 'components/new_ui/Modal/Modal';
import Table from 'components/new_ui/Table';

export default function TopicsList({ topics }) {
  const [showList, setShowList] = useState(false);

  const defaultView = topics.every((topic) => topic.attributes.default);

  const columns = [
    {
      name: 'Topic',
      selector: (row) => row.attributes.title,
      sortable: true,
    },
    {
      name: 'Number of sessions',
      selector: (row) => row.attributes.number_of_sessions,
      sortable: true,
    },
  ];

  return (
    <>
      <div className="text-end">
        <Button
          size="sm"
          className="mt-3"
          onClick={() => setShowList(true)}
          disabled={defaultView}
        >
          View all
        </Button>
      </div>

      <Modal show={showList} size="lg">
        <Table
          title="Modules"
          columns={columns}
          data={topics}
          selectableRows={false}
        />

        <footer>
          <Button
            variant="outline-primary"
            onClick={() => setShowList(false)}
          >
            Close
          </Button>
        </footer>
      </Modal>
    </>
  );
}

TopicsList.propTypes = {
  topics: PropTypes.arrayOf(PropTypes.object).isRequired,
};
